import { useState } from "react";
import { useNavigate } from "react-router-dom";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

const ViewCredits = () => {
  const navigate = useNavigate();
  const [credits, setCredits] = useState("");
  const [errMsg, setErrMsg] = useState("");
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const axiosPrivate = useAxiosPrivate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrMsg("");
    setSuccess(false);
    setLoading(true);

    try {
      const response = await axiosPrivate.get("/manager/credits");

      setSuccess(true);
      setCredits(response?.data?.credits);
    } catch (err) {
      console.error(err);
      setErrMsg(err?.response?.data?.message || err?.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fade-in" style={{ maxWidth: "600px", margin: "0 auto", padding: "2rem 1rem" }}>
      {/* Back Button */}
      <button
        className="btn-secondary"
        style={{ marginBottom: "1.5rem", padding: "0.5rem 1rem", fontSize: "0.875rem" }}
        onClick={() => navigate("/manager")}
      >
        ← Back to Dashboard
      </button>

      {/* Header */}
      <div style={{ marginBottom: "2rem", textAlign: "center" }}>
        <h1
          style={{
            fontSize: "2.5rem",
            fontWeight: "700",
            marginBottom: "0.5rem",
            background: "linear-gradient(135deg, var(--warning-amber), var(--accent-pink))",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            backgroundClip: "text",
          }}
        >
          My Credits
        </h1>
        <p style={{ color: "var(--text-muted)", fontSize: "1.125rem" }}>
          Check your available assessment credits
        </p>
      </div>

      {errMsg && <p className="errmsg">{errMsg}</p>}

      <div className="card" style={{ padding: "3rem", textAlign: "center" }}>
        {!success ? (
          <button
            className="btn-primary"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? "Checking..." : "Check Balance"}
          </button>
        ) : (
          <div className="fade-in">
            <p style={{ color: "var(--text-muted)", marginBottom: "0.5rem", textTransform: "uppercase", letterSpacing: "0.05em" }}>
              Available Balance
            </p>
            <div style={{
              fontSize: "4rem",
              fontWeight: "800",
              color: "var(--text-primary)",
              marginBottom: "2rem",
              textShadow: "0 0 20px rgba(245, 158, 11, 0.3)"
            }}>
              {credits}
            </div>

            <button className="btn-secondary" onClick={() => setSuccess(false)}>
              Refresh
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ViewCredits;
